export type FieldToUpdate =
  | 'address1'
  | 'city'
  | 'state'
  | 'country'
  | 'zipCode'


export const errorMessage = 'Please enter a valid shipping address.'

export const fieldsToUpdate: FieldToUpdate[] = [
  'address1',
  'city',
  'state',
  'country',
  'zipCode',
]
